import { DatePipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AdminDataTableComponent } from '../../../../../shared/components/admin-data-table/admin-data-table.component';
import type { AdminTableColumn } from '../../../../../shared/components/admin-data-table/admin-table-column.interface';
import type { AdminUserSummary } from '../../models/admin-user.model';
import { OnboardingStatusBadgeComponent } from '../onboarding-status-badge/onboarding-status-badge.component';

@Component({
  selector: 'app-users-table',
  standalone: true,
  imports: [
    DatePipe,
    TranslatePipe,
    AdminDataTableComponent,
    OnboardingStatusBadgeComponent,
  ],
  templateUrl: './users-table.component.html',
  styleUrl: './users-table.component.scss',
})
export class UsersTableComponent {
  users = input.required<AdminUserSummary[]>();

  viewUser = output<AdminUserSummary>();

  readonly columns: AdminTableColumn[] = [
    { id: 'user', headerKey: 'app.admin.users.table.user' },
    { id: 'role', headerKey: 'app.admin.users.table.role', thClass: 'col-narrow' },
    {
      id: 'onboarding',
      headerKey: 'app.admin.users.table.onboarding',
      thClass: 'col-center',
    },
    {
      id: 'progress',
      headerKey: 'app.admin.users.table.progress',
      thClass: 'col-progress',
    },
    {
      id: 'status',
      headerKey: 'app.admin.users.table.accountStatus',
      thClass: 'col-center',
    },
    {
      id: 'registered',
      headerKey: 'app.admin.users.table.registered',
      thClass: 'col-narrow',
    },
    {
      id: 'actions',
      headerKey: 'app.admin.users.table.actions',
      thClass: 'col-center col-actions',
    },
  ];

  readonly trackUser = (user: AdminUserSummary): string => user.id;
}
